import { connect } from 'react-redux';

import AutoGenerateGroupDialog from './AutoGenerateGroupDialog';
import {
  operations as groupOperations,
  selectors as groupSelectors,
} from '../../../../../store/groups';

const mapStateToProps = (state) => {
  const setId = groupSelectors.generateGroupsDialogOpenFor(state);
  return {
    setId,
    open: !!setId,
    generating: groupSelectors.isGeneratingGroups(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGenerate: (setId) => (generateParams) => {
    dispatch(
      groupOperations.generateGroups({
        set: setId,
        generateParams,
      })
    );
  },
  onClose: () => dispatch(groupOperations.closeGenerateGroups),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onGenerate: dispatchProps.onGenerate(stateProps.setId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AutoGenerateGroupDialog);
